import { render, staticRenderFns } from "./login-header.vue?vue&type=template&id=0a9b4521&scoped=true&"
import script from "./login-header.vue?vue&type=script&lang=js&"
export * from "./login-header.vue?vue&type=script&lang=js&"
import style0 from "./login-header.vue?vue&type=style&index=0&id=0a9b4521&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9b4521",
  null
  
)

export default component.exports